import { render, staticRenderFns } from "./videoTabPage.vue?vue&type=template&id=a9b826da&scoped=true&"
import script from "./videoTabPage.vue?vue&type=script&lang=js&"
export * from "./videoTabPage.vue?vue&type=script&lang=js&"
import style0 from "./videoTabPage.vue?vue&type=style&index=0&id=a9b826da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b826da",
  null
  
)

export default component.exports